var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"custom-add-button",style:({
    '--btn-width': _vm.btnWidth + 'px',
    '--btn-height': _vm.btnHeight + 'px',
  }),attrs:{"id":`${_vm.id}`},on:{"click":function($event){return _vm.$emit('action:click')}}},[_c(_vm.icon,{tag:"component",staticClass:"custom-add-button--icon",style:({ '--color': _vm.color })}),_c('span',{staticClass:"custom-add-button--text",style:({ '--color': _vm.color })},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }